import { Col, Row } from 'reactstrap';
import { useIntl } from 'react-intl';
import { capitalizeFirstLetter } from 'src/utils/string';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import useAuth from 'src/hooks/useAuth';
import RiscoLookup from 'src/lookups/item';
import DicionarioRiscoLookup from 'src/lookups/DicionarioRiscos/DicionarioRiscoLookup';
import GrauRiscoLookup from 'src/lookups/grau-risco';
import NivelDicionarioRiscoLookup from 'src/lookups/NivelDicionarioRiscoLookup';

const RiscoCategorizadoSearch = ({ model }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();


  return (
    <>
      <CollapsibleSection
        title={intl.formatMessage({ id: 'label.informacoesBasicas' })}
        startOpen
      >
        <Row>
          <Col md={12}>
            <RiscoLookup
              multi
              clearable
              model={{
                label: capitalizeFirstLetter(resources.riscos),
                value: model.getModel('riscos').value,
                requestChange: model.getModel('riscos').requestChange,
              }}
            />
          </Col>
          <Col md={12}>
            <GrauRiscoLookup
              multi={true}
              clearable
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'exposicao' })
                ),
                value: model.getModel('exposicao').value,
                requestChange: model.getModel('exposicao').requestChange,
              }}
            />
          </Col>
          <Col md={12}>
            <DicionarioRiscoLookup
              multi
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'categoria' })
                ),
                value: model.getModel('categoriaDicionario').value,
                requestChange: model.getModel('categoriaDicionario')
                  .requestChange,
              }}
              clearable
            />
          </Col>
          <Col md={12}>
            <NivelDicionarioRiscoLookup
              multi
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'nivel' })
                ),
                value: model.getModel('niveis').value,
                requestChange: model.getModel('niveis').requestChange,
              }}
              clearable
            />
          </Col>
        </Row>
      </CollapsibleSection>
    </>
  );
};
export default RiscoCategorizadoSearch;
